export const typography = {
  fontFamily: {
    // OpenAI-aligned system font stack (matches apps-sdk-ui)
    web: "ui-sans-serif, -apple-system, system-ui, 'Segoe UI', 'Noto Sans', 'Helvetica', 'Arial', sans-serif",
    // Google Sans-led Latin stack: adopted app-wide in apps/mobile (native
    // + web). The bundled Google Sans faces register as @font-face
    // (expo-font); 'Google Sans' (also loaded via CDN on the web build) and the
    // system fallbacks cover the brief window before they load. The plain
    // `web` stack is left untouched so apps/web (marketing) is unaffected.
    // (Key name kept as `webPoppins` for back-compat.)
    webPoppins:
      "'GoogleSans_400Regular', 'Google Sans', -apple-system, BlinkMacSystemFont, ui-sans-serif, system-ui, 'Segoe UI', 'Noto Sans', 'Helvetica', 'Arial', sans-serif",
    webArabic: "'Cairo', ui-sans-serif, -apple-system, system-ui, 'Segoe UI', 'Noto Sans', 'Helvetica', 'Arial', sans-serif",
    webMono: "ui-monospace, 'SFMono-Regular', 'SF Mono', 'Menlo', 'Monaco', 'Consolas', monospace",
    arabic: {
      regular: 'Cairo_400Regular',
      medium: 'Cairo_500Medium',
      semibold: 'Cairo_600SemiBold',
      bold: 'Cairo_700Bold',
    },
    // Google Sans native font-family names (loaded via
    // @expo-google-fonts/google-sans). Latin default for apps/mobile;
    // Arabic continues to use Cairo above. Weight keys are stepped down one face
    // (medium→Regular, semibold→Medium, bold→SemiBold) so the UI reads lighter -
    // mirror of `latinFonts` in apps/mobile FontProvider.
    // (Key name kept as `poppins` for back-compat.)
    poppins: {
      regular: 'GoogleSans_400Regular',
      medium: 'GoogleSans_400Regular',
      semibold: 'GoogleSans_500Medium',
      bold: 'GoogleSans_600SemiBold',
    },
    code: "ui-monospace, 'SFMono-Regular', 'SF Mono', 'Menlo', 'Monaco', 'Consolas', monospace",
  },
  // OpenAI heading scale (px values for React Native). +1px on every step so
  // the app reads a touch bigger, closer to reference apps like Gemini.
  headingSize: {
    '5xl': 73,
    '4xl': 61,
    '3xl': 49,
    '2xl': 37,
    xl: 33,
    lg: 25,
    md: 21,
    sm: 19,
    xs: 17,
  },
  // OpenAI body text scale. +1px on every step, mirroring headingSize above.
  fontSize: {
    '3xs': 9,
    '2xs': 11,
    xs: 13,
    sm: 15,
    base: 17,
    lg: 19,
    xl: 21,
    '2xl': 25,
    '3xl': 31,
    '4xl': 37,
  },
  fontWeight: {
    normal: '400' as const,
    medium: '500' as const,
    semibold: '600' as const,
    bold: '700' as const,
  },
  // OpenAI line-height ratios
  lineHeight: {
    none: 1,       // display headings (3xl+)
    tight: 1.2,    // medium headings
    snug: 1.3,     // heading-md
    normal: 1.5,   // body text (text-md, text-xs)
    relaxed: 1.6,  // text-lg
    loose: 1.7,    // chat messages (ChatGPT specific)
  },
};
